'use client';

import Footer from 'components/Footer';
import LogoLoader from 'components/LogoLoader';
import React from 'react';
import ClubQuickLinks from '../Dashboard/ClubQuickLinks';
import { NavbarApp } from '../ui/Navbar/NavbarApp';

interface Props {
    title?: string;
    metaDescription?: string;
    isLoading?: boolean;
    withoutContainer?: boolean;
    withoutFooter?: boolean;
    spacing?: number;
    authRequired?: boolean;
}

export const AppLayout: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    children,
    isLoading,
    withoutContainer,
    withoutFooter,
    spacing = 0
}) => {
    return (
        <>
            <NavbarApp />

            {spacing ? <div style={{ height: spacing }} /> : null}
            <div
                className={`tw-relative tw-z-0 tw-h-px  tw-px-0 tw-grid-cols-main-feature ${isLoading && 'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center'}`}
            >
                {withoutContainer ? children : isLoading ? <LogoLoader /> : children}
                <ClubQuickLinks />
                {!withoutFooter && <Footer />}
            </div>
        </>
    );
};
